import { render } from "./AutoPurchase.vue?vue&type=template&id=6ac4a39c&scoped=true"
import script from "./AutoPurchase.vue?vue&type=script&lang=js"
export * from "./AutoPurchase.vue?vue&type=script&lang=js"

import "./AutoPurchase.vue?vue&type=style&index=0&id=6ac4a39c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac4a39c"]])

export default __exports__